export default "__VITE_ASSET__83ecb38e__"